import api from '@/apis'

export default {
  state: {
    visibility: false,
    filtered_flow: [],
    type: '',
    intent_id: null,
    intent_name: null,
    column: {
      loading: false,
      topic_layers: []
    },
    diagram: {
      loading: false,
      flow: {}
    }
  },
  mutations: {
    INIT_TOPIC_DATA_FINDER_DIALOG(state, payload) {
      const { type, search, intent_id } = payload
      state.type = type
      state.intent_id = intent_id ? intent_id : null
      state.intent_name = search ? search : null

      state.visibility = true
    },
    RESET_TOPIC_DATA_FINDER_DIALOG(state) {
      state.visibility = false

      state.intent_id = null
      state.intent_name = null
      state.column = { loading: false, topic_layers: [] }
      state.diagram = { loading: false, flow: {} }
    },
    SET_TOPIC_DATA_FINDER_FILTERED_FLOW(state, payload) {
      if (payload && Object.keys(payload).length) {
        const filtered_flow = []
        const flow_id_list = Object.keys(payload)
        flow_id_list.forEach((flow_id) => {
          filtered_flow.push(payload[flow_id])
        })
        state.filtered_flow = filtered_flow
      } else state.filtered_flow = []
    },

    // Column
    SET_TOPIC_DATA_FINDER_COLUMN_LOADING(state, payload) {
      state.column.loading = payload
    },
    SET_TOPIC_DATA_FINDER_COLUMN_INTENT_NAME(state, payload) {
      state.column.intent_name = payload
    },
    SET_TOPIC_DATA_FINDER_COLUMN_TOPIC_LAYERS(state, payload) {
      state.column.topic_layers = payload
    },
    APPEND_TOPIC_DATA_FINDER_COLUMN_TOPIC_LAYERS(state, payload) {
      state.column.topic_layers.push(payload)
    },

    //  Diagram
    SET_TOPIC_DATA_FINDER_DIAGRAM_LOADING(state, payload) {
      state.diagram.loading = payload
    },
    SET_TOPIC_DATA_FINDER_DIAGRAM_FLOW(state, payload) {
      state.diagram.flow = payload
    }
  },
  actions: {
    initTopicDataFinderDialog({ commit, dispatch }, payload) {
      const params = {}
      if (payload.intent_id) params.intent_id = payload.intent_id

      commit('INIT_TOPIC_DATA_FINDER_DIALOG', payload)
      dispatch('fetchTopicLayer', params) //fetch topic layer
    },

    async fetchTopicLayer({ commit }, payload) {
      try {
        const params = payload ? payload : {}

        commit('SET_TOPIC_DATA_FINDER_COLUMN_LOADING', true)
        const response = await api.getTopicLayer(params)
        if (response.data.success) {
          if (response.data.data.length) commit('APPEND_TOPIC_DATA_FINDER_COLUMN_TOPIC_LAYERS', response.data.data)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_TOPIC_DATA_FINDER_COLUMN_LOADING', false)
      }
    },
    async fetchTopicDataFinder({ commit }, payload) {
      try {
        const params = payload ? payload : {}

        commit('SET_TOPIC_DATA_FINDER_DIAGRAM_LOADING', true)
        commit('SET_TOPIC_DATA_FINDER_DIAGRAM_FLOW', {})
        commit('SET_TOPIC_DATA_FINDER_FILTERED_FLOW', {})
        const response = await api.getTopicDataFinder(params)
        if (response.data.success) {
          commit('SET_TOPIC_DATA_FINDER_DIAGRAM_FLOW', response.data.data.intents)
          commit('SET_TOPIC_DATA_FINDER_FILTERED_FLOW', response.data.data.intents)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_TOPIC_DATA_FINDER_DIAGRAM_LOADING', false)
      }
    }
  }
}
